import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-341e0659")

_pushScopeId("data-v-341e0659")
const _hoisted_1 = { class: "select-editdata" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "middle-header-text" }, "作業ファイルを選んでください", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "header-dummy" }, null, -1)
const _hoisted_4 = { class: "template-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MiddleHeader = _resolveComponent("MiddleHeader")
  const _component_EditDataThumbnail = _resolveComponent("EditDataThumbnail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MiddleHeader, null, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.saveDatas, ([template, editData], i) => {
        return (_openBlock(), _createBlock(_component_EditDataThumbnail, {
          class: "item",
          key: editData.id,
          template: template,
          editData: editData,
          isRightMenu: i % 6 == 5
        }, null, 8, ["template", "editData", "isRightMenu"]))
      }), 128))
    ])
  ]))
})